<template>
    <div class="media-buttons" :class="containerClass">
        <!-- <my-carousel v-if="$root.is_mobile" :per-page-custom="[[0, 4], [769, 5]]" :pagination-enabled="false">
            <slide  
                v-for="(button,index) in buttons" 
                :key="index"
                @slide-click="selected(button)"
            >
                <button
                    class="media-button"
                    :class="decoreActive && button.name == active ? ' active' : ''"
                    :disabled="button.disabled"
          
                >
                    <template v-if="icons && button.icon">
                       <masked-image  :src="button.icon" class="button-icon"></masked-image>
                    </template>
                    <span v-html="button.label"></span>
                </button>
            </slide>

           
        </my-carousel> -->

        <!-- <div v-else class="buttons"> -->
        <div  class="buttons">
            <button
                v-for="(button,index) in buttons" 
                :key="index"
                class="media-button"
                :class="decoreActive && button.name == active ? ' active' : ''"
                :disabled="button.disabled"
                @click.stop="selected(button)" 
            >
                <template v-if="icons && button.icon">
                    <masked-image :src="button.icon" class="button-icon"></masked-image>
                </template>
                <span v-html="button.label"></span>
            </button>
        </div>
    </div>
</template>

<script>
import MyCarousel from '../MyCarousel'

export default {
    components: {
        'my-carousel': MyCarousel,
    },

    props: {
        active:{
            type: String,
            default: 'images'
        },

        decoreActive:{
            type: Boolean,
            default: true
        },

        icons:{
            type: Boolean,
            default: false,
        },

        containerClass:{
            type: String,
            required: false,
        },

        allButton:{
            type: Boolean,
            default: false
        },

        options: {
            type: Object,
            default() {
                return {
                    video: false,
                    virtual_tour: false,
                    images: false,
                    floor_plan: false,
                    map: false,
                }
            },
        },
    },

    data(){
        return {
            buttonConfig: [
                {
                    name: 'video',
                    icon: '/img/icons/video.svg',
                },
                {
                    name: 'virtual_tour',
                    icon: '/img/icons/virtual_tour.svg',
                },
                {
                    name: 'images',
                    icon: '/img/icons/images.svg',
                },
                {
                    name: 'floor_plans',
                    icon: '/img/icons/floor_plans.svg',
                },
                {
                    name: 'map',
                    icon: '/img/icons/map.svg',
                },
            ],
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail;
        },

        buttons(){
            //dato che le traduzioni non son pronte quando monta il componente
            //calcolo i bottoni in base alla configurazione
            //e la loro label guardando il lang
            return this
                .buttonConfig
                // .filter( button => this.options[button.name])
                .map( button => {
                    button.label = this.lang && this.lang.media 
                        ? this.lang.media[button.name] 
                        : button.name
                    button.disabled = !this.options[button.name]
                    return button
                })
        }
    },

    mounted() {
        this.$nextTick(() => {
            if(this.options.has_smartvt360 && ! this.options.has_realistico) {
                this.buttons[1].icon = '/img/icons/smartvt.svg'
            }
        })
    },

    methods: {
        selected(button) {
            if(! button.disabled) {
                setTimeout(() => {
                    this.$emit('selected', button.name)
                },0)
            }
        },
    },
}
</script>
